import { STACK, DESTINATARI, RICHIESTE } from './data/incidenti';
import type { Incidente, Destinatario, Richiesta } from './data/incidenti';

/**
 * Compone il briefing tecnico da mandare a Claude Code / Claude Design / al ticket.
 *
 * Perché è così verboso: la parte che di solito manca in una richiesta di aiuto è
 * "cosa ho già verificato" e "quali vincoli non posso violare". Senza quelle due
 * sezioni il primo giro di risposte è sempre sprecato.
 *
 * NON aggiungere qui dati personali né il testo degli atti: il briefing esce
 * dall'infrastruttura e la schermata lo dichiara all'utente.
 */
export function componiBriefing(
  inc: Incidente,
  dest: Destinatario,
  richiesta: Richiesta,
): string {
  return [
    'Sei uno sviluppatore senior che lavora su UranIA PA, piattaforma di IA per le politiche di coesione della pubblica amministrazione europea.',
    '',
    STACK,
    '',
    DESTINATARI[dest],
    '',
    '--- PROBLEMA (strato ' + inc.strato + ', ' + inc.gravita + ') ---',
    inc.titolo,
    '',
    'Sintomo: ' + inc.sintomo,
    'Contesto tecnico: ' + inc.contesto,
    'Gia verificato: ' + inc.verificato,
    'Esito atteso: ' + inc.atteso,
    '',
    RICHIESTE[richiesta],
    '',
    'Rispondi in italiano, in questo ordine e senza preamboli:',
    '1) diagnosi piu probabile',
    '2) due ipotesi alternative',
    '3) cosa fare in concreto',
    '4) come verifico che e risolto',
    '5) rischi e cosa NON fare',
  ].join('\n');
}

export const SISTEMA_ASSISTENTE =
  'Sei un ingegnere senior esperto di piattaforme per la pubblica amministrazione italiana ed europea, ' +
  'di sistemi RAG e di modelli linguistici self-hosted. Rispondi in italiano, in modo asciutto e ' +
  'verificabile. Non inventare API o percorsi di file: se un dato ti manca, dillo.';

/**
 * Unico punto in cui si parla col modello.
 *
 * IMPLEMENTAZIONE RICHIESTA: sostituire questa funzione con la chiamata al
 * VOSTRO gateway di inferenza (POST /api/assistenza), NON a un provider esterno
 * diretto dal browser: il vincolo "dati sensibili solo on-premise" è applicato
 * dal gateway e una fetch dal client lo aggirerebbe. Il gateway deve inoltre
 * scrivere la richiesta nel registro eventi.
 */
export async function chiediAssistenza(briefing: string): Promise<string> {
  const r = await fetch('/api/assistenza', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ system: SISTEMA_ASSISTENTE, prompt: briefing }),
  });
  if (!r.ok) throw new Error('Assistente non raggiungibile (HTTP ' + r.status + ').');
  const j = (await r.json()) as { testo?: string };
  if (!j.testo) throw new Error('Risposta vuota dal gateway.');
  return j.testo;
}
